import { Component, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { PolicyClient } from '@benefitsui/app/api/benefits-clients';
import { ContactData } from '../dashboard-page/dashboard-page.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Defaults } from '@benefitsui/app/shared/defaults/defaults';

@Component({
  selector: 'app-contacts-page',
  templateUrl: './contacts-page.component.html',
  styleUrls: ['./contacts-page.component.scss'],
  standalone: false
})
export class ContactsPageComponent implements OnInit {
  constructor(
    private policyClient: PolicyClient,
    private clipboard: Clipboard,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  //constants
  AccountManager = 'account manager';
  SalesRepString = 'regional sales executive';
  BrokersString = 'broker';
  CustomerSupportString = 'customer support';
  ClaimsString = 'claims department';
  LadEmail = 'LADSERVICE@symetra.com';
  ClaimsCardHeader = 'Claims department';
  ClaimsEmail = 'LADCLA@symetra.com';
  ClaimsPhone = '1-877-377-6773';
  ClaimsFax = '1-877-737-3650';
  ClaimsHours1 = 'Weekdays: 5 a.m. to 5 p.m. PT |';
  ClaimsHours2 = '8 a.m. to 8 p.m. ET';
  ClaimsAddress1 = 'Symetra Life Insurance Company';
  ClaimsAddress2 = 'PO Box 1230';
  ClaimsAddress3 = 'Enfield, CT 06083';
  PrimaryCardHeader = 'Primary contact';
  SalesRepCardHeader = 'Sales representative';
  SalesRepLabel = 'Regional Sales Executive';
  CustomerSupportCardHeader = 'Portal customer support';
  CustomerSupportLabel = 'Customer Support';
  BrokerCardHeader = 'Broker';
  BrokerLabel = 'Service Broker';
  EmailCopyText = 'Copied to clipboard!';

  //icons
  copyIcon = 'content_copy';
  checkIcon = 'check';
  emailIcon = 'email';
  phoneIcon = 'phone';
  faxIcon = 'fax';
  clockIcon = 'schedule';
  officeIcon = 'business';

  contactData!: ContactData[];
  primary = true;

  portalSupportCard: ContactData = {
    contactType: this.CustomerSupportLabel,
    name: 'Representative',
    email: 'benefitsportalsecurity@symetra.com',
    phoneNumber: '1-866-216-7708',
    primaryButton: false,
    showDivider: false,
    emailIcon: this.copyIcon,
    showCopyEmailText: false
  };

  accountManagerCard: ContactData | undefined;

  claimsCard: ContactData = {
    contactType: this.ClaimsCardHeader,
    name: this.ClaimsCardHeader,
    email: this.ClaimsEmail,
    phoneNumber: this.ClaimsPhone,
    primaryButton: false,
    showDivider: false,
    emailIcon: this.copyIcon,
    showCopyEmailText: false
  };

  salesRepCard: ContactData | undefined;
  brokersCard: ContactData[] = [];
  token = Defaults.stringEmpty;
  isLoading = true;

  ngOnInit(): void {
    this.policyClient.overview().subscribe(
      (response) => {
        const { data } = response;
        this.token = data?.policyToken ?? Defaults.stringEmpty;
          data?.contactInfo?.forEach((contact) => {
          const newContact: ContactData = {
            contactType: contact.accountType ?? Defaults.stringEmpty,
            name: contact.accountManagerName ?? Defaults.stringEmpty,
            email: contact.accountManagerEmail ?? Defaults.stringEmpty,
            phoneNumber: contact.accountManagerPhone ?? Defaults.stringEmpty,
            primaryButton: (contact.accountType.toLowerCase() ?? Defaults.stringEmpty) === this.AccountManager,
            showDivider: (contact.accountType.toLowerCase() ?? Defaults.stringEmpty) === this.AccountManager,
            emailIcon: this.copyIcon,
            showCopyEmailText: false
          };
          if (newContact.contactType.toLowerCase() === this.AccountManager) {
            const isLad = contact.accountManagerEmail.toLowerCase() === this.LadEmail.toLowerCase();
            this.accountManagerCard = isLad ? ladManagerCard : newContact;
          } else if (newContact.contactType.toLowerCase() === this.SalesRepString) {
            this.salesRepCard = newContact;
          } else if (newContact.contactType.toLowerCase() === this.BrokersString) {
            this.brokersCard.push(newContact);
          }
        });
        this.isLoading = false;
      },
      () => {
        const queryParams: Params = { token: this.token };
        if (this.router) {
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams,
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
        }
      }
    );
  }

  copyEmail(data: ContactData, index?: number) {
    const pending = this.clipboard.beginCopy(data.email);
    let remainingAttempts = 3;
    const attempt = () => {
      const result = pending.copy();
      if (!result && --remainingAttempts) {
        setTimeout(attempt);
      } else {
        pending.destroy();
      }
    };
    attempt();

    if (index !== undefined) {
      this.showCopyIconText(this.BrokersString, index);
    } else {
      switch (data.contactType.toLowerCase()) {
        case this.AccountManager:
          this.showCopyIconText(this.AccountManager);
          break;
        case this.SalesRepString:
          this.showCopyIconText(this.SalesRepString);
          break;
        case this.ClaimsString:
          this.showCopyIconText(this.ClaimsString);
          break;
        case this.CustomerSupportString:
          this.showCopyIconText(this.CustomerSupportString);
          break;
      }
    }
  }

  showCopyIconText(type: string, index?: number) {
    if (index !== undefined) {
      this.brokersCard[index].showCopyEmailText = true;
      this.brokersCard[index].emailIcon = this.checkIcon;
      setTimeout(() => {
        this.brokersCard[index].showCopyEmailText = false;
        this.brokersCard[index].emailIcon = this.copyIcon;
      }, 3000);
      return;
    } else {
      switch (type.toLowerCase()) {
        case this.AccountManager:
          if (this.accountManagerCard) {
            this.accountManagerCard.showCopyEmailText = true;
            this.accountManagerCard.emailIcon = this.checkIcon;
            setTimeout(() => {
              this.accountManagerCard!.showCopyEmailText = false;
              this.accountManagerCard!.emailIcon = this.copyIcon;
            }, 3000);
          }
          break;
        case this.SalesRepString:
          if (this.salesRepCard) {
            this.salesRepCard.showCopyEmailText = true;
            this.salesRepCard.emailIcon = this.checkIcon;
            setTimeout(() => {
              this.salesRepCard!.showCopyEmailText = false;
              this.salesRepCard!.emailIcon = this.copyIcon;
            }, 3000);
          }
          break;
        case this.ClaimsString:
          this.claimsCard.showCopyEmailText = true;
          this.claimsCard.emailIcon = this.checkIcon;
          setTimeout(() => {
            this.claimsCard.showCopyEmailText = false;
            this.claimsCard.emailIcon = this.copyIcon;
          }, 3000);
          break;
          case this.CustomerSupportString:
            this.portalSupportCard.showCopyEmailText = true;
            this.portalSupportCard.emailIcon = this.checkIcon;
            setTimeout(() => {
              this.portalSupportCard.showCopyEmailText = false;
              this.portalSupportCard.emailIcon = this.copyIcon;
            }, 3000);
            break;
      }
    }
  }

  formatDate(date: string | undefined): string {
    if (!date) {
      return Defaults.stringEmpty;
    }
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString();
  }
}

export interface StyleClasses {
  primaryStyleClass: string;
  secondaryStyleClass: string;
  contentStyleClass: string;
}

export const ladManagerCard: ContactData = {
  contactType: 'Account Manager',
  name: 'Service Team',
  email: Defaults.ladEmail,
  phoneNumber: Defaults.stringEmpty,
  primaryButton: true,
  showDivider: true,
  emailIcon: 'content_copy',
  showCopyEmailText: false
};
